module.exports = __webpack_public_path__ + "static/media/inclusion_baby_coverage.c29df0db.svg";